export default "__VITE_PUBLIC_ASSET__1357a6d6__"